import { TState } from '../../../store/calculation';

type TGetNewCountValue = {
  prevState: TState;
  newValue: number;
  productId: string;
};

export const addNewCountValue = ({ prevState, newValue, productId }: TGetNewCountValue) => {
  const isGroupProduct = prevState.complimentaryGroups.some(group =>
    group.products.some(product => product.code === productId)
  );

  if (isGroupProduct) {
    const updatedGroups = prevState.complimentaryGroups.map(group => ({
      ...group,
      products: group.products.map(product =>
        product.code === productId ? { ...product, quantity: newValue } : product
      ),
      selectedVariantProductId:
        group.selectedVariantProductId === productId ? undefined : group.selectedVariantProductId,
    }));

    return {
      ...prevState,
      complimentaryGroups: updatedGroups,
    };
  }

  return {
    ...prevState,
    complementaryProducts: prevState.complementaryProducts.map(item =>
      item.code === productId ? { ...item, quantity: newValue } : item
    ),
  };
};
